module.exports = function() {
  return new Worker(__webpack_public_path__ + "a099baeb7b1e49a2ee65.worker.js");
};